import React from 'react';
import { cn } from '../../design-system/cn';
import {
  semanticFill,
  semanticColors,
  domainColors,
  typography,
  radii,
} from '../../design-system/tokens';

const TONES = {
  error: semanticFill('danger'),
  success: semanticFill('success'),
  warning: semanticFill('warning'),
  info: semanticFill('info'),
  admin: semanticFill('admin'),
  neutral: semanticFill('neutral'),
};

export default function Alert({ tone = 'error', role = 'alert', className, children }) {
  if (!children) return null;

  return (
    <div
      role={role}
      className={cn(
        'p-3 border text-sm',
        radii.controlMd,
        TONES[tone] || TONES.error,
        className
      )}
    >
      {children}
    </div>
  );
}

/** Compact stacked alerts — matches Lockbox ALERT_TONES for future migration. */
export function AlertBanner({ tone = 'neutral', title, children, className }) {
  const { accent, info, warning, border, surface } = semanticColors;
  const toneClasses = {
    emerald: `${accent.border} ${accent.surfaceSubtle}`,
    violet: `${domainColors.admin.border} bg-violet-500/5`,
    blue: `${info.border} bg-blue-500/5`,
    amber: `${warning.border} bg-amber-500/5`,
    purple: `${domainColors.wallet.border} bg-purple-500/5`,
    gray: `${border.strong} ${surface.neutral}`,
    neutral: `${border.strong} ${surface.neutral}`,
  };

  return (
    <div
      className={cn(
        'border px-4 py-3',
        radii.card,
        toneClasses[tone] || toneClasses.neutral,
        className
      )}
    >
      {title && (
        <p className={cn(typography.microWide, semanticColors.text.label, 'mb-1')}>
          {title}
        </p>
      )}
      <div className={cn('text-sm', semanticColors.text.onDark)}>{children}</div>
    </div>
  );
}
